import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { IChatState } from 'interfaces/chat.interfaces copy';
import { IMessage, ReplyToMessageProps } from 'interfaces/message.interface';
import { UserData } from 'interfaces/UserData.interface';

export const initialState: IChatState = {
  inboxUsers: [],
  currentIndex: 0,
  loading: true,
  onlineUsers: [],
  offlineUsers: [],
  replyToMessage: undefined,
  lastMessage: undefined,
  chatLoaded: false,
};

export const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    addInboxUsers: (
      state: IChatState,
      action: PayloadAction<{ user: UserData; lastMessageTime: number }>
    ) => {
      if (state.inboxUsers.some(e => e.user.name === action.payload.user.name))
        return;
      else state.inboxUsers.push(action.payload);
    },
    setCurrentIndex: (state: IChatState, action: PayloadAction<number>) => {
      if (action.payload === -1) state.currentIndex = 0;
      else state.currentIndex = action.payload;
    },
    setLoading: (state: IChatState, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setOnlineUsers: (state: IChatState, action: PayloadAction<number[]>) => {
      state.onlineUsers = action.payload;
      const onlineUsersInOfflineUsers = state.onlineUsers.filter(userId =>
        state.offlineUsers.includes(userId)
      );
      onlineUsersInOfflineUsers.forEach(userId => {
        state.offlineUsers.splice(state.offlineUsers.indexOf(userId), 1);
      });
    },
    addOfflineUser: (state: IChatState, action: PayloadAction<number>) => {
      if (state.offlineUsers.includes(action.payload)) return;
      else {
        state.offlineUsers.push(action.payload);
      }
    },
    updateReplyToMessage: (
      state: IChatState,
      action: PayloadAction<ReplyToMessageProps>
    ) => {
      if (action.payload.id) state.replyToMessage = { ...action.payload };
      else state.replyToMessage = undefined;
    },
    updateLastMessage: (
      state: IChatState,
      action: PayloadAction<IMessage | undefined>
    ) => {
      if (action.payload) {
        state.lastMessage = { ...action.payload };
      } else state.lastMessage = undefined;
    },
    updateLastMessageTime: (
      state: IChatState,
      action: PayloadAction<{ userId: number; lastMessageTime: number }>
    ) => {
      const index = state.inboxUsers.findIndex(
        user => action.payload.userId === user.user.id
      );
      state.inboxUsers[index].lastMessageTime = action.payload.lastMessageTime;
    },
    setChatLoaded: (state: IChatState) => {
      state.chatLoaded = true;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  addInboxUsers,
  setCurrentIndex,
  setLoading,
  setOnlineUsers,
  addOfflineUser,
  updateReplyToMessage,
  updateLastMessage,
  updateLastMessageTime,
  setChatLoaded,
} = chatSlice.actions;
export const selectChat = (state: RootState) => state.chat;

export default chatSlice.reducer;
